import axios from 'axios'
import NProgress from 'nprogress/nprogress.js'
import Notifications from 'react-notification-system-redux'
import initializers from '../dependencies/initializers'

export function fetchArticlesData() {
	return (dispatch, getState) => {
		return axios({
			url: initializers.api_host + '/public/v1/articles',
			timeout: 20000,
			method: 'get',
			responseType: 'json',
			headers: {'X-Requested-With': 'XMLHttpRequest'}
		})
		.then((response) => {
			if (response.data) {
				dispatch({
					type: 'ARTICLES_DATA_FETCH_SUCCESS',
					articlesData: response.data
				})
			}
		})
		.catch((error) => {
			dispatch(Notifications.error({
				title: 'Error',
				message: 'An error occurred when fetching university data.',
				position: 'bl'
			}))

			dispatch({
				type: 'ARTICLES_DATA_FETCH_ERROR',
				error: error.message
			})

			throw error
		})
	}
}

export function fetchWpPosts(page = 1, perPage = 8) {
	return (dispatch, getState) => {
		NProgress.start()
		
		return axios({
			url: initializers.api_host + `/public/v1/wp-posts?page=${page}&perPage=${perPage}`,
			timeout: 20000,
			method: 'get',
			responseType: 'json',
			headers: {'X-Requested-With': 'XMLHttpRequest'}
		})
		.then((response) => {
			NProgress.done()
			
			if (response.data) {
				dispatch({
					type: 'WP_POSTS_FETCH_SUCCESS',
					wpPosts: response.data.data,
					pagination: response.data.pagination
				})
			}
		})
		.catch((error) => {
			NProgress.done()
			
			dispatch(Notifications.error({
				title: 'Error',
				message: 'An error occurred when fetching blog posts.',
				position: 'bl'
			}))

			dispatch({
				type: 'WP_POSTS_FETCH_ERROR',
				error: error.message
			})

			throw error
		})
	}
}

export function fetchLatestWpPosts(count = 4) {
	return (dispatch, getState) => {
		return axios({
			url: initializers.api_host + `/public/v1/wp-posts?page=1&perPage=${count}`,
			timeout: 20000,
			method: 'get',
			responseType: 'json',
			headers: {'X-Requested-With': 'XMLHttpRequest'}
		})
		.then((response) => {
			if (response.data) {
				dispatch({
					type: 'LATEST_WP_POSTS_FETCH_SUCCESS',
					latestWpPosts: response.data.data
				})
			}
		})
		.catch((error) => {
			dispatch(Notifications.error({
				title: 'Error',
				message: 'An error occurred when fetching latest blog posts.',
				position: 'bl'
			}))

			dispatch({
				type: 'LATEST_WP_POSTS_FETCH_ERROR',
				error: error.message
			})

			throw error
		})
	}
}

export function fetchWpPostById(postId) {
	return (dispatch, getState) => {
		NProgress.start()

		let url = `${initializers.blog_host}/wp-json/wp/v2/posts/${postId}?_embed`;
		if (isNaN(postId)) {
			url = `${initializers.blog_host}/wp-json/wp/v2/posts?slug=${(postId)}&_embed`;
		}
		return axios({
			url,
			timeout: 20000,
			method: 'get',
			responseType: 'json',
			headers: {'X-Requested-With': 'XMLHttpRequest'}
		})
		.then((response) => {
			NProgress.done()
			
			if (response.data) {
				const data = (Array.isArray(response.data) ? response.data[0] : response.data);
				
				// Extract tag names from embedded data if available
				if (data._embedded && data._embedded['wp:term']) {
					const termArrays = data._embedded['wp:term'];
					if (termArrays.length > 1 && termArrays[1]) {
						// Tags are in the second array (index 1)
						const tagTerms = termArrays[1];
						data.tag_names = tagTerms.map(tag => tag.name);
					} else {
						// Fallback: filter all terms for tags
						const allTerms = termArrays.flat();
						const tags = allTerms.filter(term => term.taxonomy === 'post_tag');
						data.tag_names = tags.map(tag => tag.name);
					}
				} else if (data.tags && data.tags.length > 0) {
					// If embedded tags not available, fetch tag details separately
					const tagIds = data.tags.join(',');
					return axios({
						url: `${initializers.blog_host}/wp-json/wp/v2/tags?include=${tagIds}`,
						timeout: 20000,
						method: 'get',
						responseType: 'json',
						headers: {'X-Requested-With': 'XMLHttpRequest'}
					})
					.then((tagResponse) => {
						if (tagResponse.data) {
							data.tag_names = tagResponse.data.map(tag => tag.name);
						}
						dispatch({
							type: 'WP_POST_BY_ID_FETCH_SUCCESS',
							wpPostDetail: data
						});
						return;
					})
					.catch(() => {
						// If tag fetch fails, continue without tag names
						dispatch({
							type: 'WP_POST_BY_ID_FETCH_SUCCESS',
							wpPostDetail: data
						});
						return;
					});
				}
				
				dispatch({
					type: 'WP_POST_BY_ID_FETCH_SUCCESS',
					wpPostDetail: data
				})
			}
		})
		.catch((error) => {
			NProgress.done()
			
			dispatch(Notifications.error({
				title: 'Error',
				message: 'An error occurred when fetching blog post.',
				position: 'bl'
			}))

			dispatch({
				type: 'WP_POST_BY_ID_FETCH_ERROR',
				error: error.message
			})

			throw error
		})
	}
}

export function searchWpPosts(searchQuery, page = 1, perPage = 8) {
	return (dispatch, getState) => {
		NProgress.start()
		
		const searchParam = searchQuery.trim() ? `&search=${encodeURIComponent(searchQuery.trim())}` : ''
		
		return axios({
			url: initializers.api_host + `/public/v1/wp-posts?page=${page}&perPage=${perPage}${searchParam}`,
			timeout: 20000,
			method: 'get',
			responseType: 'json',
			headers: {'X-Requested-With': 'XMLHttpRequest'}
		})
		.then((response) => {
			NProgress.done()
			
			if (response.data) {
				dispatch({
					type: 'WP_POSTS_SEARCH_SUCCESS',
					wpPosts: response.data.data,
					pagination: response.data.pagination,
					searchQuery: searchQuery
				})
			}
		})
		.catch((error) => {
			NProgress.done()
			
			dispatch(Notifications.error({
				title: 'Error',
				message: 'An error occurred when searching blog posts.',
				position: 'bl'
			}))

			dispatch({
				type: 'WP_POSTS_SEARCH_ERROR',
				error: error.message
			})

			throw error
		})
	}
}

export function fetchWpPostsByCategory(category, page = 1, perPage = 8) {
	return (dispatch, getState) => {
		NProgress.start()
		
		const categoryParam = category && category !== 'all' ? `&category=${category}` : ''
		
		return axios({
			url: initializers.api_host + `/public/v1/wp-posts?page=${page}&perPage=${perPage}${categoryParam}`,
			timeout: 20000,
			method: 'get',
			responseType: 'json',
			headers: {'X-Requested-With': 'XMLHttpRequest'}
		})
		.then((response) => {
			NProgress.done()
			
			if (response.data) {
				dispatch({
					type: 'WP_POSTS_CATEGORY_FETCH_SUCCESS',
					wpPosts: response.data.data,
					pagination: response.data.pagination,
					selectedCategory: category
				})
			}
		})
		.catch((error) => {
			NProgress.done()
			
			dispatch(Notifications.error({
				title: 'Error',
				message: 'An error occurred when fetching blog posts by category.',
				position: 'bl'
			}))

			dispatch({
				type: 'WP_POSTS_CATEGORY_FETCH_ERROR',
				error: error.message
			})

			throw error
		})
	}
}
